import { useState, useEffect } from 'react';
import './VideoPopup.css';
import { API_BASE_URL } from '../services/ApiService';

const DEFAULT_TUTORIAL_URL = 'https://siemens-my.sharepoint.com/personal/maytal_rubinstein_siemens_com/_layouts/15/stream.aspx?id=%2Fpersonal%2Fmaytal%5Frubinstein%5Fsiemens%5Fcom%2FDocuments%2F%5FDM%20Learning%20Day%2FGeneral%20Information%2FLD%5FPLM%2FPLM%5FLearning%20Day%5FTutorial%2Emp4&ga=1';
const DEFAULT_TUTORIAL_TEXT = 'Watch our Learning Day tutorial to learn how to navigate the platform.';
const DEFAULT_TUTORIAL_BTN = '▶ Watch Tutorial';

const VideoPopup = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [tutorialUrl, setTutorialUrl] = useState(DEFAULT_TUTORIAL_URL);
  const [tutorialText, setTutorialText] = useState(DEFAULT_TUTORIAL_TEXT);
  const [tutorialBtnText, setTutorialBtnText] = useState(DEFAULT_TUTORIAL_BTN);
  const [tutorialActive, setTutorialActive] = useState(true);
  const [popupActive, setPopupActive] = useState(false);
  const [optionalVideos, setOptionalVideos] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/settings/public`)
      .then(r => {
        if (!r.ok) throw new Error(`Settings request failed: ${r.status}`);
        return r.json();
      })
      .then(data => {
        const s = data.data || {};
        if (s.watch_tutorial_url) setTutorialUrl(s.watch_tutorial_url);
        if (s.watch_tutorial_text) setTutorialText(s.watch_tutorial_text);
        if (s.watch_tutorial_button_text) setTutorialBtnText(s.watch_tutorial_button_text);
        setTutorialActive(s.watch_tutorial_active !== 'false');
        setPopupActive(s.videos_popup_active === 'true');
        try {
          const videos = JSON.parse(s.optional_videos || '[]');
          const now = new Date();
          const active = videos.filter(v =>
            v.active !== false &&
            (!v.end_date || new Date(v.end_date) >= now)
          );
          setOptionalVideos(active);
        } catch { /* keep empty */ }
      })
      .catch(() => { /* keep defaults */ });
  }, []);

  if (!popupActive || !isOpen) return null;

  return (
    <div className="video-popup">
      <div className="video-popup-header">
        <span>📹 Tutorial Video</span>
        <span className="video-popup-close" onClick={() => setIsOpen(false)}>×</span>
      </div>
      <div className="video-popup-body">
        {tutorialActive && (
          <>
            <p>{tutorialText}</p>
            <button
              className="video-popup-btn"
              onClick={() => window.open(tutorialUrl, '_blank', 'noopener,noreferrer')}
            >
              {tutorialBtnText}
            </button>
          </>
        )}
        {optionalVideos.map((video, idx) => (
          <div key={idx} style={{ marginTop: '8px' }}>
            {video.extra_text && (
              <p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#6b7280' }}>{video.extra_text}</p>
            )}
            <button
              className="video-popup-btn"
              onClick={() => window.open(video.url, '_blank', 'noopener,noreferrer')}
            >
              {video.button_text || `🎬 ${video.title}`}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VideoPopup;
